import React from 'react';
import Footer from '../components/Footer';

const Partners = () => {
  const partners = [
    {
      name: 'Ministry Connect',
      logo: 'https://placehold.co/200x100/374151/FFFFFF/svg?text=Ministry+Connect',
      description: 'Leading provider of digital solutions for ministry organizations, helping churches and faith-based groups leverage technology for greater impact.',
      link: '#'
    },
    {
      name: 'Faith Forward',
      logo: 'https://placehold.co/200x100/374151/FFFFFF/svg?text=Faith+Forward',
      description: 'International ministry focused on equipping the next generation of spiritual leaders through mentorship and training programs.',
      link: '#'
    },
    {
      name: 'Global Discipleship',
      logo: 'https://placehold.co/200x100/374151/FFFFFF/svg?text=Global+Discipleship',
      description: 'Worldwide network of discipleship organizations working together to spread the message of Christ across cultures and continents.',
      link: '#'
    },
    {
      name: 'Family First',
      logo: 'https://placehold.co/200x100/374151/FFFFFF/svg?text=Family+First',
      description: 'Dedicated to strengthening family bonds through Christ-centered programs and resources for parents and children.',
      link: '#'
    },
    {
      name: 'Spirit Tech',
      logo: 'https://placehold.co/200x100/374151/FFFFFF/svg?text=Spirit+Tech',
      description: 'Innovative technology solutions provider specializing in platforms that connect and empower faith-based communities.',
      link: '#'
    },
    {
      name: 'Mission Forward',
      logo: 'https://placehold.co/200x100/374151/FFFFFF/svg?text=Mission+Forward',
      description: 'Strategic consulting firm helping religious organizations maximize their impact through data-driven insights and modern methodologies.',
      link: '#'
    }
  ];

  return (
    <>
      <div className="bg-gradient-to-b from-gray-50 to-white py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          {/* Header Section */}
          <div className="mx-auto max-w-2xl text-center mb-16">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              Our Strategic Partners
            </h2>
            <p className="mt-6 text-lg leading-8 text-gray-600">
              We work with leading organizations who share our vision of empowering spiritual growth and discipleship worldwide.
            </p>
          </div>

          {/* Partners Grid */}
          <div className="mx-auto mt-16 grid max-w-lg grid-cols-1 items-center gap-x-8 gap-y-12 sm:max-w-xl sm:grid-cols-2 sm:gap-x-10 lg:mx-0 lg:max-w-none lg:grid-cols-3">
            {partners.map((partner) => (
              <div 
                key={partner.name}
                className="group relative bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden"
              >
                <div className="p-6">
                  {/* Logo */}
                  <div className="flex justify-center mb-6 p-4 bg-gray-50 rounded-xl">
                    <img
                      src={partner.logo}
                      alt={partner.name}
                      className="max-h-12 object-contain"
                    />
                  </div>

                  {/* Partner Name */}
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">
                    {partner.name}
                  </h3>

                  {/* Description */}
                  <p className="text-sm text-gray-600 mb-4">
                    {partner.description}
                  </p>

                  {/* Learn More Link */}
                  <a
                    href={partner.link}
                    className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500"
                  >
                    Learn more
                    <svg
                      className="ml-2 h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* Call to Action */}
          <div className="mt-20 text-center">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              Interested in Partnering with Us?
            </h3>
            <p className="text-gray-600 mb-8">
              Join our network of organizations making a difference in spiritual mentorship.
            </p>
            <a
              href="/contact"
              className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Partners;
